module.exports = __webpack_public_path__ + "static/img/max_pictgrid26_980x876.c86d67e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid26_980x876.jpg
// module id = CrU9
// module chunks = 0